import { render } from "./ManagerAddModal.vue?vue&type=template&id=6e894b2a"
import script from "./ManagerAddModal.vue?vue&type=script&lang=js"
export * from "./ManagerAddModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/imac/projects/java/marketplace/wallet/wallet.console.web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__